<template>
  <div id="Money">
    <van-nav-bar
      title="我的钱包"
      left-text="返回"
      right-
      left-arrow
      @click-left="back"
      @click-right="history">
      <template #right>
        <van-icon name="todo-list-o" size="20"/>
      </template>
    </van-nav-bar>
    <div class="remain">
      <div class="num">{{money}}</div>
      <div class="msg">当前余额</div>
    </div>
    <div class="main">
      <div class="title">会员套餐</div>
      <div class="menu">
        <div v-for="(item,index) in menu" :key="index" class="item" :class="{ choosed: index==choose }" @click="choose=index">
          <div class="price"><span>{{item.price}}</span> 跆拳币</div>
          <div class="money">{{item.money}}元</div>
        </div>
      </div>
    </div>
    <div class="other">
      <span class="point"></span>
      跆拳币充值成功后，不能退款、提现或者转赠他人
    </div>
    <div class="buy clearfix">
      <div class="price">￥{{menu[choose].money}}.00</div>
      <van-button type="default" class="btn" @click="buy">立即购买</van-button>
    </div>
    <van-popup v-model="show" position="bottom" class="popup" closeable>
      <div class="title">确认购买</div>
      <div class="item clearfix">
        <div class="name">商品名称</div>
        <div class="msg">跆拳币充值</div>
      </div>
      <div class="item clearfix">
        <div class="name">实付金额</div>
        <div class="msg price">￥{{menu[choose].money}}.00</div>
      </div>
      <div>
        <div class="paychoose">支付方式</div>
        <van-radio-group v-model="radio">
          <van-cell-group :border="false">
            <van-cell title="单选框 1" clickable @click="radio = '1'" :border="false">
              <template #title>
                <img src="/img/wechat.png" alt="" class="alipay-icon">
                <span class="alipay">微信支付</span>
              </template>
              <template #right-icon>
                <van-radio name="1" checked-color="#FFD10E"/>
              </template>
            </van-cell>
            <van-cell title="单选框 2" clickable @click="radio = '2'" :border="false">
              <template #title>
                <img src="/img/zhifubao.png" alt="" class="alipay-icon">
                <span class="alipay">支付宝</span>
              </template>
              <template #right-icon>
                <van-radio name="2" checked-color="#FFD10E"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <van-button type="default" class="btn" @click="pay">确认支付</van-button>
    </van-popup>


    <div v-html="alipayWap" ref="alipayWap"></div>
  </div>
</template>
<script>
//import { Toast } from 'vant';
import { MessageBox } from 'mint-ui'
//import cookie from '@/util/cookie'
export default {
  data(){
    return{
      uid:'',
      sign:'',
      responseType: 'code',
      scope: 'snsapi_base',
      state:'',
     // signature:'70EA570631E4BB79628FBCA90534C63FF7FADD89',
      signType:'MD5',
      packageName:'',
      nonce:'e61463f8efa94090b1f366cccfbbb555',
      timestamp:'1395712658',
      code:'',
      appId:'wx46275192851d3b99',
      redirect_uri:'https://m.gxtkd.org.cn/money',
      choose:0,
      money:0,
      show:false,
      alipayWap: '',
      radio:"1",
      menu:[
        {
          price:8,
          money:8
        },
        {
          price:30,
          money:28
        },
        {
          price:88,
          money:83
        },
        {
          price:188,
          money:180
        },
        {
          price:388,
          money:378
        },
        {
          price:788,
          money:750
        },
      ]
    }
  },
  methods:{
    back(){
      this.$router.go(-1);
    },
    history(){
      console.log("查看历史");
      this.$router.replace({path:'/home/bill'});
    },
    buy(){
      console.log("支付",this.menu[this.choose].price);
      this.show=true;
    },
    extractQueryParams (url) {
    let queryParams = {}
    if (url.includes('?')) {
    let queryString = url.substr(url.indexOf('?') + 1)
    let pairs = queryString.split('&')
    for(let pair of pairs) {
      let splitArray = pair.split('=')
      let key = splitArray[0]
      let value = splitArray[1]
      if (value.indexOf('#') > -1) {
        value = value.substring(0, value.indexOf('#'))
      }

      queryParams[key] = value
    }
  }
  return queryParams
  },
  async getAuthCode(){
        await this.redirectToAuthPageUrl()
        let queryParams = this.extractQueryParams(window.location.href)
        this.code = queryParams.code
        //alert(code)
        //let callbackUrl = queryParams.callbackUrl
        //console.log(callbackUrl)
        //if (code) {
          //window.location.href = this.redirect_uri + '?code=' + code
        //}
    },
  redirectToAuthPageUrl(){
        let authParams = `?appid=${this.appId}&redirect_uri=${this.redirect_uri}&response_type=${this.responseType}&state=${this.state}&scope=${this.scope}#wechat_redirect`
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize' + authParams
  },
  onBridgeReady(){
                window.WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                        "appId":this.appId,     //公众号名称，由商户传入
                        "timeStamp":this.timestamp,         //时间戳，自1970年以来的秒数
                        "nonceStr":this.nonce, //随机串
                        "package":this.packageName,
                        "signType":this.signType,         //微信签名方式：
                        "paySign":this.signature //微信签名
                    },
                    function(res){
                        if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                            MessageBox.alert('充值成功！','')      // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                        } else{
                            MessageBox.alert('充值失败，请重新充值','')
                        }
                    }
                )
  },
  isWeChat(){
                if (typeof WeixinJSBridge == "undefined"){
                    MessageBox.alert('请在微信客户端进行支付操作','')
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false)
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady())
                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady())
                    }
                }else{
                    this.onBridgeReady()
                }
    },
    //            从后台获取微信支付接口所需信息
    getWeChatPayInfo(){
                //api.getWeChatPayInfo({
                  this.axios.post('/wechat/wePay',{
                    "uid": this.uid,
                    "price": this.menu[this.choose].price,
                    "body":"箐动会员充值",
                    "openid": this.sign,
                    "appId" :this.appId
                })
                    .then((res)=>{
                        if(res.data[0]){
                            this.signature = res.data[0].signature
                            this.appId = res.data[0].appId
                            this.signType = res.data[0].signType
                            this.packageName = res.data[0].packageName
                            this.nonce = res.data[0].nonce
                            this.timestamp = res.data[0].timestamp
                            this.isWeChat()
                        }
                    })
            },
  pay(){
      if(this.radio ==1){
                    if(this.menu[this.choose].price == '0.0' ){
                        this.show=false;
                        MessageBox.alert('请选择充值金额','')
                        return
                    } else{
                      
                      this.sign = sessionStorage.getItem('sign')
                        if(this.sign && this.sign!=''){
                            this.getWeChatPayInfo()
                        } else {
                             this.getAuthCode();
                            //api.getOpenid({
                              this.axios.post('/wechat/getOpenid',{
                                "code":this.code,
                                "uid": this.uid
                            })
                                .then((res)=>{
                                    if(res.result == 1){
                                        this.sign = res.data[0].openid
                                        this.getWeChatPayInfo()
                                    } else{
                                        this.show=false;
                                        MessageBox.alert(res.msg)
                                    }
                                })
                        }
                    }
                } else {
                    this.show=false;
                    MessageBox.alert('暂时不支持支付宝支付','')
                    return
                }
     }
  },
   getReady(){
            this.getAuthCode();
            this.uid= sessionStorage.getItem("uid");
            //this.uid = cookie.get('uid')
            if(this.uid && this.uid!=''){            
                this.code = location.href.substring(location.href.indexOf('=')+1,location.href.indexOf('&'))
//                this.uid = location.href.substring(location.href.indexOf('#')-1,location.href.indexOf('#'))
                // api.getOpenid({
                  this.axios.post('/wechat/getOpenid',{
                    "code":this.code,
                    "uid": this.uid
                })
                    .then((res)=>{
                        if(res.result == 1){
                            //cookie.set("sign", res.data[0].openid)
                            sessionStorage.set("sign", res.data[0].openid)
                        } else{
                            MessageBox.alert(res.msg)
                        }
                    })
            } else {
                MessageBox.alert('请登录','').then(()=>{
                    this.$router.push({name:'login'})
                })
            }
        },
  created(){
    var id = sessionStorage.getItem("uid");
    //this.uid = cookie.get('uid')
    this.uid=id;
    this.axios.post("/vip/getMoney",{
      id:id
    })
    .then(res=>{
      console.log(res.data);
      if(res.data.code=='200'){
        this.money = res.data.data
      }
    })
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/base.less";
.van-nav-bar__text,.van-nav-bar .van-icon{
  color: @buttonColor;
}
#Money{
  background: @lineColor;
  height: 617px;
}
.remain{
  background: white;
  text-align: center;
  padding: 25px;
  .num{
    font-size: 40px;
    font-weight: 600;
  }
  .msg{
    color: gray;
    margin-top: 10px;
  }
}
.main{
  margin-top: 5px;
  background: white;
  padding: 20px;
  .menu{
    display: flex;
    justify-content: space-around;
    flex-wrap:wrap;
    .item{
      margin-top: 20px;
      width: 100px;
      border: 1px solid gray;
      text-align: center;
      border-radius: 5px;
      
      padding: 10px 0; 
      .price{
        line-height: 40px;
        span{
          font-size: 26px;
          font-weight: bold;
          display: inline-block;
        }
      }
      .money{
        color: gray;
        line-height: 30px;
      }
    }
    .choosed{
      background: rgba(255, 239, 198, 0.295);
      border: 1px solid rgb(190, 140, 0);
    }
  }
}
.other{
  margin-top: 5px;
  background: white;
  font-size: 14px;
  line-height: 30px;
  padding: 10px 20px;
  .point{
    display: inline-block;
    width: 5px;
    height: 5px;
    background: @mainColor;
    border-radius: 50%;
    vertical-align: middle;
  }
}
.buy{
  background: white;
  width: 100%;
  line-height: 50px;
  position: fixed;
  bottom: 50px;
  .price{
    color:rgb(190, 140, 0);
    font-weight: bold;
    float: left;
    padding-left: 10px;
  }
  .btn{
    float: right;
    height: 50px;
    border: none;
    width: 120px;
    background: #5A5A5A;
    color:#DEBF94;
  }
}
.popup{
  background: white;
  // height: 240px;
  .title{
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
  }
  .item{
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid rgb(233, 233, 233);
    .name{
      float: left;
    }
    .msg{
      float: right;
    }
  }
  .alipay{
    display: inline-block;
    line-height: 30px;
    height: 30px;
  }
  .alipay-icon{
    width: 30px;
    height: 30px;
    vertical-align: middle;
  }
  .paychoose{
    padding: 0 20px;
    color: gray;
    line-height: 50px;
  }
  .btn{
    float: right;
    height: 50px;
    border: none;
    width: 100%;
    background: #5A5A5A;
    color:#DEBF94;
  }
  .price{
    color:rgb(190, 140, 0);
    font-weight: bold;
    // float: left;
    // padding-left: 10px;
  }
}

</style>